import Fechar from '@mui/icons-material/Close';
import Filtrar from '@mui/icons-material/FilterList';
import { IconButton, TextField, Tooltip, Typography } from '@mui/material';
import { action, makeObservable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import ReactComponent from './ReactComponent';
import IconeLimpar from './sessao/icones/IconeLimpar';

class PainelFiltrosToolbar extends ReactComponent {
    fecharPainelFiltros = () => {
        this.store.painelFiltros = false;
    };

    filtrar = () => {
        this.fecharPainelFiltros();
    };

    limparFiltros = () => {
        this.store.alterandoValorFiltro = true;
        setTimeout(
            () =>
                runInAction(() => {
                    this.store.resetFiltros();
                    this.store.alterandoValorFiltro = false;
                }),
            10
        );
    };

    handleChangePesquisa = (event) => {
        this.store.valorCampoPesquisaFiltros = event.target.value;
    };

    handleClickLimpar = () => {
        this.store.valorCampoPesquisaFiltros = '';
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            fecharPainelFiltros: action,
            filtrar: action,
            limparFiltros: action,
            handleChangePesquisa: action,
            handleClickLimpar: action
        });
    }

    render() {
        const corIconeFiltrar = this.store.existeFiltroAtivo ? 'secondary' : 'primary';
        return (
            <Fragment>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                        <h2 style={{ margin: '0px' }}>Filtros</h2>
                        <h4 style={{ color: 'red', fontSize: '9pt', margin: '8px 32px 8px 0px', textAlign: 'justify' }}>
                            <Typography fontSize={'small'}>
                                * ATENÇÃO: as opções e os totalizadores são calculados dinamicamente de acordo com os
                                filtros selecionados, com base nos dados previamente carregados. Sugere-se recarregar os
                                dados da sessão caso seja observada alguma inconsistência.
                            </Typography>
                        </h4>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip title={'Filtrar'}>
                            <IconButton
                                color={corIconeFiltrar}
                                aria-label="Filtrar"
                                onClick={this.filtrar}
                                style={{ display: 'flex', alignItems: 'center' }}
                                size="large"
                            >
                                <Filtrar />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'Limpar Filtros'}>
                            <IconButton
                                color="primary"
                                aria-label="Limpar"
                                onClick={this.limparFiltros}
                                style={{ display: 'flex', alignItems: 'center' }}
                                size="large"
                            >
                                <IconeLimpar style={{ fill: '#01579b' }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'Fechar'}>
                            <IconButton
                                color="primary"
                                aria-label="Fechar"
                                onClick={this.fecharPainelFiltros}
                                style={{ display: 'flex', alignItems: 'center' }}
                                size="large"
                            >
                                <Fechar />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '8px' }}>
                    <TextField
                        label="Pesquisar filtro por nome"
                        value={this.store.valorCampoPesquisaFiltros}
                        onChange={this.handleChangePesquisa}
                        style={{ width: '220px' }}
                    />
                    <Tooltip
                        title="Limpar pesquisa"
                        placement="top"
                    >
                        <span>
                            <IconeLimpar
                                style={{ cursor: 'pointer', margin: '8px 10px', minWidth: '24px' }}
                                onClick={this.handleClickLimpar}
                            />
                        </span>
                    </Tooltip>
                </div>
            </Fragment>
        );
    }
}

export default inject('stores')(observer(PainelFiltrosToolbar));
